import { usePumpSizing } from "../../../context/PumpSizingContext";
import { Button } from "../../shared/Button";

export function StartAgainButton() {
	const { startAgain } = usePumpSizing();

	return (
		<Button variant="secondary" onClick={startAgain}>
			<span>Start Again</span>
		</Button>
	);
}
